import { combineReducers } from 'redux';
import loginReducer from './login';
import commonReducer from './common';
import controlReducer from './control';
import oprationLogReducer from './oprationLog';
import singleVehiclePageReducer from './singleVehiclePage';
import scheduleOrderReducer from './order';
import warningListPageReducer from './warningListPage';
import impassableAreaPageReducer from './impassableAreaPage';
import workOrder from './workOrder';
import cockpitInfo from './cockpitInfo';

export const rootReducer = combineReducers({
  login: loginReducer,
  common: commonReducer,
  response: controlReducer,
  operationRecord: oprationLogReducer,
  singleVehiclePageInfo: singleVehiclePageReducer,
  orderListData: scheduleOrderReducer,
  alarmRecordData: warningListPageReducer,
  impassableAreaPageData: impassableAreaPageReducer,
  workOrder: workOrder,
  cockpitInfo: cockpitInfo,
});
